import { render, staticRenderFns } from "./r-attribute-items.vue?vue&type=template&id=19f13314"
import script from "./r-attribute-items.vue?vue&type=script&lang=js"
export * from "./r-attribute-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f13314')) {
      api.createRecord('19f13314', component.options)
    } else {
      api.reload('19f13314', component.options)
    }
    module.hot.accept("./r-attribute-items.vue?vue&type=template&id=19f13314", function () {
      api.rerender('19f13314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/attribute/r-attribute-items.vue"
export default component.exports